/** Get object keys */
export function objectKeys(object) {
    return Object.keys(object);
}
//# sourceMappingURL=objectKeys.js.map